import { GetApiV1ThreeLetterCodeClientAdminsClientAdminUsers200 } from '@fukuri-admins/apis/client/gen/model';
import { getEmail } from '@fukuri-admins/utils/common/cookies';
import { formatDate } from '@fukuri-admins/utils/common/date';
import { AdminUserListPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof AdminUserListPresentation>;
type Args = {
  data: GetApiV1ThreeLetterCodeClientAdminsClientAdminUsers200;
};
type IConvertToPresentationProps = (args: Args) => {
  users: PresentationProps['users'];
};

export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => {
  const currentUserEmail = getEmail();
  const users = data.client_admin_users.map(user => ({
    id: user.id,
    name: user.full_name,
    email: user.email,
    createdAtLabel: formatDate({
      date: new Date(user.created_at * 1000),
      formatType: 'yyyy/M/d H:mm',
    }),
    isCurrentUser: user.email === currentUserEmail,
  }));

  return {
    users,
  };
};
